import React from 'react'
import { useStyles } from './styles'
import { Button } from 'src/components'
import { PastureDto, pastureStatusLabels } from 'src/dto/pasture.dto'

interface PastureClassificationProps {
  openHistoric: () => void
  setShowAnimaisFromLocalModal: (value: boolean) => void
  data: PastureDto
}

export const PastureClassification: React.FC<PastureClassificationProps> = ({
  data,
  openHistoric,
  setShowAnimaisFromLocalModal
}) => {
  const styles = useStyles()

  const { pasto, cerca, aguados, saleiros } = data

  return (
    <section className={styles.classificationContainer}>
      <h2>Classificações</h2>
      <div className={styles.classificationContent}>
        <div className={styles.classificationItem}>
          <span>Local:</span> <span>{pastureStatusLabels[pasto!] || ''}</span>
        </div>
        <div className={styles.classificationItem}>
          <span>Cerca:</span> <span>{pastureStatusLabels[cerca!] || ''}</span>
        </div>
        <div className={styles.classificationItem}>
          <span>Aguadas:</span> <span>{pastureStatusLabels[aguados!] || ''}</span>
        </div>
        <div className={styles.classificationItem}>
          <span>Salerias:</span> <span>{pastureStatusLabels[saleiros!] || ''}</span>
        </div>
      </div>

      <div className={styles.classificationFooter}>
        <div className={styles.classificationFooterContent}>
          <Button outlined onClick={openHistoric}>
            Historico do Local
          </Button>
          <Button onClick={() => setShowAnimaisFromLocalModal(true)}>Ver Animais</Button>
        </div>
      </div>
    </section>
  )
}
